module.exports = __webpack_public_path__ + "static/assets/367d7189e8dac8a0ca2828830a91db83.mp3";